import React from 'react';
import styles from './Person.module.scss';
import { Alt } from '@heading';
import { ArrowLink } from '@input';
import classNames from 'classnames';
import { isString } from 'lodash';
import Img from 'gatsby-image';

export default function Person({
  name,
  pronouns,
  role,
  photo,
  showPhoto = true,
  info,
  photoSize,
  className,
  hasShadow,
  fullWidth,
  slug
}) {
  if (pronouns) {
    const parts = pronouns
      .trim()
      .replace(/^\(|\)$/g, '')
      .split('/');

    pronouns = parts.map((p, index) => (
      <span key={index}>{p.trim()}</span>
    ));
  }

  role = role?.split(/\n|\|/).map((text, index) => (
    <span
      className={styles.lineBreak}
      key={index}
    >
      {text}
    </span>
  ));

  return !name ? null : (
    <div
      className={classNames(styles.wrapper, className, {
        [styles.shadow]: hasShadow,
        [styles.fullWidth]: fullWidth,
        [styles.hasPhoto]: !!photo
      })}
    >
      {showPhoto && (
        <div
          style={{
            width: photoSize,
            height: photoSize,
            backgroundImage: isString(photo) ? `url(${photo})` : null
          }}
          className={styles.photo}
        >
          {photo && !isString(photo) && (
            <React.Fragment>
              {photo.childImageSharp ? (
                <Img
                  alt=""
                  fadeIn={false}
                  {...photo.childImageSharp}
                />
              ) : (
                photo
              )}
            </React.Fragment>
          )}
        </div>
      )}
      <div className={styles.content}>
        <div className={styles.name}>
          <Alt>{name}</Alt>{' '}
          {pronouns && <span className={styles.pronouns}>{pronouns}</span>}
        </div>
        {role && <div className={styles.title}>{role}</div>}
        {info && (
          <div className={styles.info}>
            {isString(info) ? <p>{info}</p> : info}
          </div>
        )}
        {slug && (
          <div className={styles.links}>
            <ArrowLink to={slug}>View profile</ArrowLink>
          </div>
        )}
      </div>
    </div>
  );
}

export function PeopleWrapper({ className, children }) {
  return !children ? null : (
    <div
      className={classNames(styles.peopleWrapper, className)}
      data-count={React.Children.count(children)}
    >
      {children}
    </div>
  );
}
